import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

import BusSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Onibus.svg';
import BusFillSrc from 'assets/images/icons/DesignSysten2.0/location_transport/OnibusFill.svg';
import MetroSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Metrô.svg';
import MetroFillSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Metrô Fill.svg';
import MetroFill2Src from 'assets/images/icons/DesignSysten2.0/location_transport/Metrô Fill Orange.svg';
import IntegrationStationSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Transporte Coletivo.svg';
import BikeSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Bicicleta.svg';
import BikeStationSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Estação Bicicleta.svg';
import TurnstilesInSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Catraca Entrada.svg';
import TurnstilesOutSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Catraca Saida.svg';
import TurnstilesBlockedSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Catraca Bloqueada.svg';
import ReleaseRatchetSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Liberar Catracas.svg';
import FerryFillSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Balsa.svg';
import CarSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Carro.svg';
import PedestrianSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Pedestre.svg';
import PinSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Pin.svg';
import ConventionalSeatSrc from 'assets/images/icons/DesignSysten2.0/location_transport/ConventionalSeat.svg';
import BedSeatSrc from 'assets/images/icons/DesignSysten2.0/location_transport/BedBedSeat.svg';
import ExecutiveSeatSrc from 'assets/images/icons/DesignSysten2.0/location_transport/ExecutiveSeat.svg';
interface SVGInlineInterface {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const ReleaseRatchet: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ReleaseRatchetSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const TurnstilesBlocked: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill,
}) => (
  <SVG
    src={TurnstilesBlockedSrc}
    style={{ width, height }}
    cacheRequests={true}
  />
);

export const TurnstilesOut: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill,
}) => (
  <SVG src={TurnstilesOutSrc} style={{ width, height }} cacheRequests={true} />
);

export const TurnstilesIn: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill,
}) => (
  <SVG src={TurnstilesInSrc} style={{ width, height }} cacheRequests={true} />
);

export const Bike: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={BikeSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const BikeStation: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={BikeStationSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const IntegrationStation: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={IntegrationStationSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Bus: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={BusSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const BedSeat: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={BedSeatSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const ExecutiveSeat: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ExecutiveSeatSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const ConventionalSeat: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ConventionalSeatSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const BusFill: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={BusFillSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Metro: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={MetroSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const MetroFill: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={MetroFillSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const MetroFill2: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={MetroFill2Src}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const FerryFill: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill = '#14171A',
}) => (
  <SVG
    src={FerryFillSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Car: React.FC<SVGInlineInterface> = ({ width, height, fill }) => (
  <SVG
    src={CarSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Pedestrian: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={PedestrianSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Pin: React.FC<SVGInlineInterface> = ({ width, height, fill }) => (
  <SVG
    src={PinSrc}
    style={{ width, height }}
    cacheRequests={true}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
